/* =====================================================================
 * TEMPORARY "Logo Lab" — floating, draggable panel to try logos + size +
 * padding in the header and footer, live. NOT a public feature.
 *
 * TURN ON:   add ?logolab to the URL of any page you want to preview on
 *            (e.g. /?logolab). It shows ONLY on that page — it does not follow
 *            you across the site. The × closes it and strips the param, so a
 *            refresh won't reopen it. Add ?logolab again to bring it back.
 * REMOVE:    delete {% render 'logo-lab' %} from layout/theme.liquid,
 *            then delete snippets/logo-lab.liquid + assets/logo-lab.js.
 *
 * Logos are tightly cropped to the mark, so "size" is honest across all of
 * them; the "pad" slider adds consistent breathing room separately.
 * Self-contained Web Component with Shadow DOM. The chosen logo/size/pad
 * values persist (localStorage) so they survive a refresh of the same page.
 * ===================================================================== */
(function () {
  // Show ONLY on a page whose URL carries ?logolab (or #logolab). No cross-page
  // persistence — it does not follow you around the site. Add the param to any
  // page you want to preview on; the × closes it and strips the param.
  var urlOn = /[?&#]logolab\b/i.test(location.search + location.hash);
  if (!urlOn) return;
  if (customElements.get('logo-lab')) return;

  var OPTIONS = (window.__LOGO_LAB__ && window.__LOGO_LAB__.options) || [];
  var TARGETS = {
    header: { label: 'Header logo', sel: '.adg-hdr__logo img', min: 28, max: 110, def: 70, padMax: 40 },
    footer: { label: 'Footer logo', sel: '.adg-ft__logo img',  min: 40, max: 150, def: 80, padMax: 40 }
  };
  var KEY = 'adgLogoLab.v1';
  var load = function () { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
  var save = function (s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} };
  var nameOf = function (id) { var o = OPTIONS.filter(function (x) { return x.id === id; })[0]; return o ? o.name : id; };

  class LogoLab extends HTMLElement {
    connectedCallback() {
      this.state = load();
      Object.keys(TARGETS).forEach((w) => {
        this.state[w] = this.state[w] || {};
        if (!this.state[w].logo) this.state[w].logo = 'seal';
        if (!this.state[w].size) this.state[w].size = TARGETS[w].def;
        if (this.state[w].pad == null) this.state[w].pad = 0;
      });
      this.attachShadow({ mode: 'open' });
      this.build();
      this.apply();
      this.updateSummary();
    }

    imgFor(which) { return document.querySelector(TARGETS[which].sel); }

    apply() {
      Object.keys(TARGETS).forEach((which) => {
        var img = this.imgFor(which); if (!img) return;
        var st = this.state[which] || {};
        var opt = OPTIONS.filter((o) => o.id === st.logo)[0];
        if (opt) img.src = opt.url;
        img.style.setProperty('height', (st.size || TARGETS[which].def) + 'px', 'important');
        img.style.setProperty('width', 'auto', 'important');
        img.style.setProperty('max-height', 'none', 'important');
        img.style.setProperty('padding', (st.pad || 0) + 'px 0', 'important'); // vertical only — Justin 7/16
        img.style.setProperty('box-sizing', 'content-box', 'important');
      });
    }

    build() {
      var css = `
        :host{ all:initial; }
        *{ box-sizing:border-box; font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif; }
        .panel{ position:fixed; top:80px; right:20px; z-index:2147483647; width:300px; max-width:calc(100vw - 24px);
          background:#fff; color:#231F20; border:1px solid #d8d9dd; border-radius:12px;
          box-shadow:0 10px 40px rgba(0,0,0,.28); overflow:hidden; font-size:13px; }
        .bar{ display:flex; align-items:center; gap:8px; padding:9px 10px; background:#231F20; color:#fff; cursor:grab; user-select:none; touch-action:none; }
        .bar:active{ cursor:grabbing; }
        .bar b{ font-size:12px; letter-spacing:.04em; text-transform:uppercase; flex:1; }
        .bar button{ background:rgba(255,255,255,.14); color:#fff; border:none; width:22px; height:22px; border-radius:6px; cursor:pointer; font-size:13px; line-height:1; }
        .bar button:hover{ background:rgba(255,255,255,.28); }
        .body{ padding:12px; max-height:76vh; overflow:auto; }
        .grp{ margin-bottom:13px; }
        .grp-t{ font-weight:700; margin-bottom:7px; font-size:12px; }
        .opts{ display:grid; grid-template-columns:repeat(4,1fr); gap:6px; }
        .opt{ background:#f6f6f7; border:2px solid transparent; border-radius:8px; padding:5px 3px; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:3px; }
        .opt:hover{ background:#eee; }
        .opt.sel{ border-color:#FF4A06; background:#fff; }
        .opt img{ width:100%; height:34px; object-fit:contain; display:block; }
        .opt span{ font-size:9px; line-height:1.1; text-align:center; color:#4c4c4c; }
        .sz{ display:flex; align-items:center; gap:8px; margin-top:7px; font-size:12px; }
        .sz>i{ font-style:normal; min-width:30px; color:#4c4c4c; }
        .sz input{ flex:1; accent-color:#FF4A06; }
        .sz b{ min-width:40px; text-align:right; font-variant-numeric:tabular-nums; }
        .sum{ background:#FFF3EE; border:1px solid #FFD5C4; border-radius:8px; padding:9px 10px; margin:2px 0 10px; }
        .sum-t{ font-size:10px; text-transform:uppercase; letter-spacing:.05em; color:#c23c00; font-weight:700; margin-bottom:5px; }
        .sum-row{ display:flex; justify-content:space-between; font-size:12px; padding:2px 0; gap:8px; }
        .sum-row span{ color:#8a4a2a; }
        .sum-row b{ color:#231F20; text-align:right; }
        .foot{ display:flex; align-items:center; justify-content:space-between; gap:8px; }
        .foot .note{ font-size:10px; color:#8a8a8a; }
        .reset{ background:#fff; border:1px solid #d8d9dd; border-radius:7px; padding:5px 10px; cursor:pointer; font-size:12px; font-weight:600; }
        .reset:hover{ background:#f6f6f7; }
        @media (max-width:520px){ .panel{ right:8px; left:8px; top:auto; bottom:8px; width:auto; } .opt img{ height:30px; } }`;

      var groups = Object.keys(TARGETS).map((w) => this.groupHTML(w)).join('');
      this.shadowRoot.innerHTML =
        '<style>' + css + '</style>' +
        '<div class="panel">' +
          '<div class="bar" data-drag><b>Logo Lab</b>' +
            '<button data-min title="Minimize">–</button>' +
            '<button data-close title="Turn off">×</button></div>' +
          '<div class="body">' + groups +
            '<div class="sum"><div class="sum-t">Your picks — give these to Justin</div>' +
              '<div class="sum-row"><span>Header</span><b data-sum="header">—</b></div>' +
              '<div class="sum-row"><span>Footer</span><b data-sum="footer">—</b></div></div>' +
            '<div class="foot"><span class="note">Temporary tool</span><button class="reset" data-reset>Reset</button></div>' +
          '</div></div>';
      this.panel = this.shadowRoot.querySelector('.panel');
      this.wire();
    }

    groupHTML(which) {
      var t = TARGETS[which], st = this.state[which] || {}, cur = st.logo;
      var size = st.size || t.def, pad = st.pad != null ? st.pad : 0;
      var opts = OPTIONS.map((o) =>
        '<button class="opt' + (o.id === cur ? ' sel' : '') + '" data-opt data-which="' + which + '" data-id="' + o.id + '">' +
          '<img src="' + o.url + '" alt="' + o.name + '"><span>' + o.name + '</span></button>').join('');
      return '<div class="grp"><div class="grp-t">' + t.label + '</div><div class="opts">' + opts + '</div>' +
        '<label class="sz"><i>Size</i><input type="range" data-size data-which="' + which + '" min="' + t.min + '" max="' + t.max + '" value="' + size + '"><b data-val="' + which + '">' + size + 'px</b></label>' +
        '<label class="sz"><i>Pad</i><input type="range" data-pad data-which="' + which + '" min="0" max="' + t.padMax + '" value="' + pad + '"><b data-padval="' + which + '">' + pad + 'px</b></label></div>';
    }

    updateSummary() {
      Object.keys(TARGETS).forEach((which) => {
        var st = this.state[which] || {};
        var el = this.shadowRoot.querySelector('[data-sum="' + which + '"]');
        if (el) el.textContent = nameOf(st.logo || 'seal') + '  ·  ' + (st.size || TARGETS[which].def) + 'px  ·  ' + (st.pad || 0) + 'px pad (top/bottom)';
      });
    }

    wire() {
      var self = this;
      this.shadowRoot.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-opt]'); if (opt) { self.pick(opt.dataset.which, opt.dataset.id); return; }
        if (e.target.closest('[data-min]')) { self.body().hidden = !self.body().hidden; return; }
        if (e.target.closest('[data-close]')) { self.close(); return; }
        if (e.target.closest('[data-reset]')) { self.resetDefaults(); return; }
      });
      this.shadowRoot.addEventListener('input', function (e) {
        var s = e.target.closest('[data-size]'); if (s) { self.setNum(s.dataset.which, 'size', s.value, 'val'); return; }
        var p = e.target.closest('[data-pad]');  if (p) { self.setNum(p.dataset.which, 'pad', p.value, 'padval'); return; }
      });
      this.drag(this.shadowRoot.querySelector('[data-drag]'));
    }
    body() { return this.shadowRoot.querySelector('.body'); }

    close() {
      // Remove the panel and strip ?logolab from the URL so a refresh won't reopen it.
      this.remove();
      try {
        var u = new URL(location.href);
        u.searchParams.delete('logolab');
        if (/^#?logolab$/i.test(u.hash)) u.hash = '';
        history.replaceState(null, '', u.href);
      } catch (x) {}
    }

    resetDefaults() {
      // Clear saved picks, restore defaults, re-render in place. Stays OPEN.
      try { localStorage.removeItem(KEY); } catch (x) {}
      var self = this;
      this.state = {};
      Object.keys(TARGETS).forEach(function (w) {
        self.state[w] = { logo: 'seal', size: TARGETS[w].def, pad: 0 };
      });
      save(this.state);
      this.build();
      this.apply();
      this.updateSummary();
    }

    pick(which, id) {
      this.state[which] = this.state[which] || {}; this.state[which].logo = id; save(this.state); this.apply();
      this.shadowRoot.querySelectorAll('[data-opt][data-which="' + which + '"]').forEach(function (b) { b.classList.toggle('sel', b.dataset.id === id); });
      this.updateSummary();
    }
    setNum(which, prop, v, lblAttr) {
      this.state[which] = this.state[which] || {}; this.state[which][prop] = +v; save(this.state); this.apply();
      var lbl = this.shadowRoot.querySelector('[data-' + lblAttr + '="' + which + '"]'); if (lbl) lbl.textContent = v + 'px';
      this.updateSummary();
    }

    drag(handle) {
      var self = this, sx, sy, ox, oy, on = false;
      handle.addEventListener('pointerdown', function (e) {
        // Don't start a drag (or capture the pointer) when a control in the bar
        // is pressed — otherwise the capture swallows the × / minimize clicks.
        if (e.target.closest('button')) return;
        on = true; handle.setPointerCapture(e.pointerId);
        var r = self.panel.getBoundingClientRect();
        self.panel.style.left = r.left + 'px'; self.panel.style.top = r.top + 'px';
        self.panel.style.right = 'auto'; self.panel.style.bottom = 'auto';
        sx = e.clientX; sy = e.clientY; ox = r.left; oy = r.top;
      });
      handle.addEventListener('pointermove', function (e) {
        if (!on) return;
        self.panel.style.left = Math.max(4, Math.min(window.innerWidth - 40, ox + e.clientX - sx)) + 'px';
        self.panel.style.top = Math.max(4, Math.min(window.innerHeight - 30, oy + e.clientY - sy)) + 'px';
      });
      handle.addEventListener('pointerup', function () { on = false; });
      handle.addEventListener('pointercancel', function () { on = false; });
    }
  }

  customElements.define('logo-lab', LogoLab);
  var mount = function () { if (!document.querySelector('logo-lab')) document.body.appendChild(document.createElement('logo-lab')); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
